module.exports = __webpack_public_path__ + "static/img/pic_home_fapiao.24fdb47.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/pic_home_fapiao.png
// module id = ATJG
// module chunks = 83